<div
  class="bg-surface-inverse dark:bg-surface-inverse-darkmode text-on-surface-inverse dark:text-on-surface-inverse-darkmode py-2 px-4 rounded-md"
>
  <ng-content />
</div>
